import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=666c75ec&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"
import style0 from "../style.scss?vue&type=style&index=0&id=666c75ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c75ec",
  null
  
)

export default component.exports